import { render } from "./InsideMenu.vue?vue&type=template&id=3b8ab066"
import script from "./InsideMenu.vue?vue&type=script&lang=js"
export * from "./InsideMenu.vue?vue&type=script&lang=js"

import "./InsideMenu.vue?vue&type=style&index=0&id=3b8ab066&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__